/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Row, Col, Form} from "react-bootstrap";

import {AiOutlineCheck} from "react-icons/all";


type FormCheckboxFieldType = {
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    xl?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    fieldCheckedStatus: boolean;
    fieldCheckedStatusHandler(): void;
    fieldLabel: string;
    fieldLabelClickHandler?(): void;
    fieldError?: string | null;
    fieldDisabledStatus?: boolean;
    cssClasses?: string;
    fileSourceHandler?: any;
};


export const FormCheckboxFieldComponent: React.FC<FormCheckboxFieldType> = ({
    xs = 12, lg= null, sm= null, xl = null,
    fieldCheckedStatus, fieldCheckedStatusHandler,
    fieldLabel = "", fieldLabelClickHandler = null,
    fieldError = null,
    fieldDisabledStatus = false,
    cssClasses = "", fileSourceHandler = null,
}): JSX.Element => {

    cssClasses = (cssClasses ? `${cssClasses} ` : "") + "form-field-component checkbox-field-component";

    const checkboxClasses = ["checkbox"];

    if (fieldCheckedStatus === true) checkboxClasses.push("checked")
    if (fieldCheckedStatus !== true && !!fieldError) checkboxClasses.push("error");


    return (
        <Col xs={xs} sm={sm || xs} lg={lg || sm || xs} xl={xl || lg || sm || xs} className={cssClasses}>
            <Row className={"form-field-content"}>

                <Col xs={2} lg={1} className={"checkbox-field-input"}>
                    <span className={checkboxClasses.join(" ")} onClick={fieldDisabledStatus ? undefined : fieldCheckedStatusHandler}>
                         {!!fieldCheckedStatus && <AiOutlineCheck />}
                    </span>
                </Col>

                <Col xs={10} lg={11} className={"checkbox-field-label"}>
                    <Form.Label onClick={() => fieldLabelClickHandler ? fieldLabelClickHandler() : null}>
                        {fieldLabel}
                    </Form.Label>
                    {fieldCheckedStatus !== true && !!fieldError &&
	                <Form.Label className={"error"}>{fieldError}</Form.Label>
                    }
                </Col>

            </Row>
        </Col>
    );

};


export default FormCheckboxFieldComponent;
